import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
// import { SocketIoModule, SocketIoConfig } from 'ng-socket-io';
// const config: SocketIoConfig = { url: '', options: {} };
// const config: SocketIoConfig = { url: 'https://socket.cryptoxchange.com/', options: { transports: ['websocket'] } };
import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { MenuItems } from './shared/menu-items/menu-items';
import { BreadcrumbsComponent } from './layout/admin/breadcrumbs/breadcrumbs.component';
import { HttpModule } from '@angular/http';
import { RouteGuard } from './shared/route-guard/routeguarde.guard';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { SharedService } from './theme/services/shared';


@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    BreadcrumbsComponent
  ],
  imports: [
    BrowserModule, 
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpModule,
    SharedModule,
    // SocketIoModule.forRoot(config),
    ToasterModule.forRoot()
  ],
  providers: [MenuItems, RouteGuard, ToasterModule, ToasterService, SharedService],
  bootstrap: [AppComponent]
})
export class AppModule { }
